import Constant from '@/common/constant/Constant';
import { deleteForm, updateFormField } from '@/service/formManagementService';

import Utils from '@/common/utils/utils';
import { tr } from '@/common/utils/tr';
import { cloneDeep } from 'lodash';
import { removeFieldInListByRegionDropId, setExpandMoreField } from './FormListHandler';
import {
    sortFieldListByCreator,
    isAddNewField,
    buildCreateFieldRequest,
    generateItemFieldStatus,
    generateItemFieldTag,
    validateFieldList,
    buildEditFieldRequest,
    isUseFieldInForm,
    sortFieldListByOrder
} from './CommonHandler';
import systemField from '@/common/constant/SystemField';
import {
    getFieldListByCorporation,
} from '@/service/formManagementService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import trI18n from '@/common/utils/trI18n';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

/**
 * Handle event change field filter
 * @param {*} fieldFilter 
 * @param {*} argsCommon 
 */
export const handleEventChangeFieldFilter = (fieldFilter, argsCommon) => {
    let typeFilter = fieldFilter.type;
    let usingForm = fieldFilter.usingForm;
    let fieldListByFilter = [];
    let systemFieldByFilter = [];

    // filter by type filter
    switch (typeFilter) {
        case 'all':
            fieldListByFilter = cloneDeep(argsCommon.fieldListInState);
            systemFieldByFilter = systemField;
            break;
        case Constant.FORM_DEFINITION.SYSTEM:
            fieldListByFilter = argsCommon.fieldListInState.filter(
                field =>
                    field.definition === Constant.FORM_DEFINITION.SYSTEM ||
                    field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
            );
            systemFieldByFilter = systemField;
            break;
        case Constant.FORM_DEFINITION.SAMPLE:
            fieldListByFilter = [];
            systemFieldByFilter = [];
            break;
        // default field list by affiliationProject
        default:
            systemFieldByFilter = [];

            fieldListByFilter = cloneDeep(argsCommon.fieldListInState);
            fieldListByFilter = fieldListByFilter.filter(
                field =>
                    field.affiliationProject === typeFilter ||
                    field.affiliationOrganization === typeFilter
            );
            break;
    }
    //  filter by usingForm
    switch (usingForm) {
        case 'all':
            break;
        case 'use':
            fieldListByFilter = fieldListByFilter.filter(field => isUseFieldInForm(field, argsCommon.formList, argsCommon));
            systemFieldByFilter = systemFieldByFilter.filter(field => isUseFieldInForm(field, argsCommon.formList, argsCommon));
            break;
        case 'unuse':
            fieldListByFilter = fieldListByFilter.filter(field => !isUseFieldInForm(field, argsCommon.formList, argsCommon));
            systemFieldByFilter = systemFieldByFilter.filter(field => !isUseFieldInForm(field, argsCommon.formList, argsCommon));
            break;
        default:
            break;
    }
    argsCommon.setSystemFieldList(systemFieldByFilter);
    argsCommon.setFieldList(fieldListByFilter);
};



/**
 * onDragEndHandlerFieldList
 * @param {*} event 
 * @param {*} argsCommon 
 * @returns 
 */
export const onDragEndHandlerFieldList = (event, argsCommon) => {
    if (argsCommon.fieldAddList.length === 0) {
        argsCommon.setIsChangeData(true);
    }
    
    if (!event.destination) return;

    let startIndex = event.source.index;
    let endIndex = event.destination.index;

    let listFieldAddToForm = cloneDeep(argsCommon.fieldDragDropList);
    let fieldListForUpdate = Utils.isEmpty(argsCommon.fieldListForUpdate) ? {} : cloneDeep(argsCommon.fieldListForUpdate);
    let fieldAddList = Utils.isEmpty(argsCommon.fieldAddList) ? [] : cloneDeep(argsCommon.fieldAddList);

    let [removed] = listFieldAddToForm.splice(startIndex, 1);
    listFieldAddToForm.splice(endIndex, 0, removed);

    let fieldListClone = cloneDeep(argsCommon.fieldList);
    const projectId = argsCommon.projectDetail.id;

    // update order
    listFieldAddToForm.forEach((field, index) => {
        if (isAddNewField(field)) {
            let indexInList = Utils.findIndexInArrayById(field.id, fieldAddList);
            fieldAddList[indexInList].order[`${projectId}`] = index;
        } else {
            let fieldClone = cloneDeep(field);
            let order = Utils.convertJSONDataToObject(fieldClone.order)
            fieldClone.order = order
            fieldClone.order[`${projectId}`] = index;
            fieldListForUpdate[`${fieldClone.id}`] = fieldClone;

            let fieldIndex = Utils.findIndexInArrayById(field.id, fieldListClone);
            if (fieldIndex !== -1) {
                let currentOrder = Utils.convertJSONDataToObject(fieldListClone[fieldIndex].order) || {};
                currentOrder[`${projectId}`] = index;
                fieldListClone[fieldIndex].order = currentOrder;
            }
        }
    });

    // update data
    argsCommon.setFieldLisForUpdate(fieldListForUpdate);
    argsCommon.setFieldAddList(fieldAddList);
    listFieldAddToForm = listFieldAddToForm.filter(
        (field) =>
            !(
                !Constant.AI_TELEPHONE_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST.includes(
                    field.sysField
                ) && field?.sysField?.startsWith(Constant.ID_PREFIX.AI_TELEPHONE_FIELD_ID_PREFIX)
            )
    );
    argsCommon.setFieldDragDropList(listFieldAddToForm);
    argsCommon.setFieldList(fieldListClone);

    // enable slide and set current start index
    let newSetting;
    newSetting = { ...argsCommon.settingSlideRecoilState };
    newSetting.disable = false;
    argsCommon.setSettingSlideRecoilState(newSetting);
};




/**
 * onBeforeDragStartHandlerFieldList
 * @param {*} event 
 * @param {*} argsCommon 
 */
export const onBeforeDragStartHandlerFieldList = (event, argsCommon) => {
    // disable slide before drag start
    let newSetting = { ...argsCommon.settingSlideRecoilState };
    newSetting.disable = true;

    argsCommon.setSettingSlideRecoilState(newSetting);
};


/**
 * Auto scroll to edit field
 * @param {*} argsCommon 
 */
export const autoScrollToEditField = argsCommon => {
    // auto scroll to edit field
    let scroll = document.getElementById(argsCommon.currentUpdateField.id);
    if (argsCommon.panelScreen === Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD
        && !Utils.isEmptyObject(argsCommon.currentUpdateField) && scroll !== null) {
        scroll.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
};


/**
 * Check show btn duplicate item
 * @param {*} field 
 * @param {*} item 
 * @returns isShowBtnDuplicateItem
 */
export const isShowBtnDuplicateItem = (field, item) => {
    if (Utils.isEmpty(item) || Utils.isEmpty(field)) {
        return false;
    }
    if (Utils.isEmptyArray(field.itemList)) {
        return false;
    }
    let indexExist = Utils.findIndexInArrayById(item.id, field.itemList);
    return indexExist !== -1;
};


/**
 * Init observer add field
 * @param {*} argsCommon 
 * @returns 
 */
export const initObserverAddField = argsCommon => {
    // config auto scroll add field
    let targetNode = document.getElementById(argsCommon.blockFieldListId);
    let config = { attributes: true, childList: true, subtree: true };

    // create observer
    let observerAddField = new MutationObserver((mutationsList, observer) => {
        if (argsCommon.isAutoScrollToAddField) {
            // disable auto scroll to add field
            argsCommon.setIsAutoScrollToAddField(false);
            // if field use list empty then scroll by system field list

            // auto scroll to new field
            argsCommon.fieldRefList[argsCommon.newFieldId]?.current?.scrollIntoView();
        }
    });
    observerAddField.observe(targetNode, config);

    return observerAddField;
};


/**
 * Handler close field expand more
 * @param {*} argsCommon 
 * @param {*} field 
 */
export const onCloseFieldExpandMore = (argsCommon, field) => {
    switch (argsCommon.parentPanelScreen) {
        case Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD:
            // new Name of field
            let indexInFieldAddList = Utils.findIndexInArrayById(field.id, argsCommon.fieldAddList);

            // check in fieldList
            let fieldList = cloneDeep(argsCommon.fieldList);
            let indexInFieldList = Utils.findIndexInArrayById(field.id, fieldList);
            if (indexInFieldList !== -1) {
                fieldList[indexInFieldList].name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList].name);
                fieldList[indexInFieldList].isShowInfo = false;
                fieldList[indexInFieldList].isUsingProject = argsCommon.fieldAddList[indexInFieldAddList].isUsingProject;
            } else {
                field.isShowInfo = false;
                field.name = cloneDeep(argsCommon.fieldAddList[indexInFieldAddList].name);
                field.isUsingProject = argsCommon.fieldAddList[indexInFieldAddList].isUsingProject;
                fieldList = fieldList.concat([field]);
            }
            argsCommon.setFieldList(fieldList);

            // check in fieldTypeSelectedList 
            let indexInFieldTypeSelectedList = Utils.findIndexInArrayById(field.id, argsCommon.fieldTypeSelectedList);
            if (indexInFieldTypeSelectedList !== -1) {
                let fieldTypeSelectedList = Utils.removeItemInArrayById(field.id, argsCommon.fieldTypeSelectedList);
                argsCommon.setFieldTypeSelectedList(fieldTypeSelectedList);
            }
            break;
        case Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM:
        case Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM:
            setExpandMoreField(argsCommon, argsCommon.currentAddField, argsCommon.regionDropIdBlock);
            break;
        default:
            break;
    }
};

/**
 * Remove current gui add field
 * @param {*} argsCommon 
 */
export const removeCurrentGUIAddField = argsCommon => {
    argsCommon.setIsChangeData(true);
    // reset fieldType selected
    let isRemoveInFieldSelected = !Utils.isEmptyArray(argsCommon.fieldTypeSelectedList)
        && (Utils.findIndexInArrayById(argsCommon.currentAddField.id, argsCommon.fieldTypeSelectedList) !== -1);
    if (isRemoveInFieldSelected) {
        let fieldTypeSelectedList = Utils.removeItemInArrayById(argsCommon.currentAddField.id, argsCommon.fieldTypeSelectedList);
        argsCommon.setFieldTypeSelectedList(fieldTypeSelectedList);
    }

    // reset field add list
    let isRemoveInFieldAddList = !Utils.isEmptyArray(argsCommon.fieldAddList)
        && (Utils.findIndexInArrayById(argsCommon.currentAddField.id, argsCommon.fieldAddList) !== -1);
    if (isRemoveInFieldAddList) {
        let fieldAddList = Utils.removeItemInArrayById(argsCommon.currentAddField.id, argsCommon.fieldAddList);
        argsCommon.setFieldAddList(fieldAddList);
    }

    // remove in field list
    let isRemoveInFieldList = !Utils.isEmptyArray(argsCommon.fieldList)
        && (Utils.findIndexInArrayById(argsCommon.currentAddField.id, argsCommon.fieldList) !== -1);
    if (isRemoveInFieldList) {
        let fieldList = Utils.removeItemInArrayById(argsCommon.currentAddField.id, argsCommon.fieldList);
        argsCommon.setFieldList(fieldList);
    }

    // removeFieldInListByRegionDropId
    if (Utils.isEmptyString(argsCommon.formName) || argsCommon.formEdit) argsCommon.setIsChangeData(false);
    removeFieldInListByRegionDropId(argsCommon, argsCommon.currentAddField, argsCommon.regionDropIdBlock);
};

/**
 * Get project name of field
 * @param {*} field 
 * @param {*} projectList 
 * @returns projectName
 */
export const getProjectNameOfField = (field, projectList) => {
    let projectName = '';
    if (isSystemField(field)) {
        // 'システム' is a fixed system label -> translate it. Project names are
        // identifiers and must NOT be translated, so they stay as-is.
        return tr('システム');
    }

    let project = projectList.find(item => item.id === field.affiliationProject);
    projectName = Utils.isEmptyObject(project) ? '' : Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name);

    return projectName;
};

export const getOrgName = (allListCorp, orgId) => {
    const orgDetail = allListCorp?.find(org => {
        return org.id === orgId;
    });

    // Organization names are identifiers (not translated). Only the fixed status
    // suffix '(停止中)' is translated.
    let orgName = Utils.isEmptyString(orgDetail?.title) ? '' : orgDetail?.title;
    return orgDetail?.active === Constant.CORPORATION_ACTIVE.BLOCK ? `${orgName} ${tr('(停止中)')}` : orgName;
};


/**
 * Check system field
 * @param {*} field 
 * @returns isSystemField
 */
export const isSystemField = field => {
    // return !Utils.isEmptyString(field.sysield);
    return field.definition === 'SYSTEM'
};

export const displayExpandField = (field) => {
    return !isSystemField(field) && (!isSystemField(field) || field.sysField === 'outline')
}

/**
 * 
 * @param {*} field 
 * @returns 
 */
export const isShowDuplicateButton = (field) => {
    return ![Constant.CLIENT_FIELD_TYPE.ADD_NEW_FIELD, Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD].includes(field.clientFieldType);
}

/**
 * Validate field input
 * @param {*} argsCommon
 * @returns isValidateError
 */
export const validateFieldInput = argsCommon => {
    // validate field list
    // let fieldList = cloneDeep(argsCommon.fieldList);
    let isValidateError = false;

    // let fieldListValidateResult = validateFieldList(fieldList, isValidateError, argsCommon.fieldListInState);
    // isValidateError = fieldListValidateResult.isValidateError;
    // argsCommon.setFieldList(fieldListValidateResult.fieldList);

    // validate add field list
    let fieldAddList = cloneDeep(argsCommon.fieldAddList);
    let fieldAddListValidateResult = validateFieldList(fieldAddList, isValidateError, argsCommon.fieldListInState);
    isValidateError = fieldAddListValidateResult.isValidateError;
    argsCommon.setFieldAddList(fieldAddListValidateResult.fieldList);

    return isValidateError;
};

/**
 * Handler event submit field
 * @param {*} argsCommon 
 */
export const onSubmitAddField = async argsCommon => {
    argsCommon.setIsLoading(true);
    // validate data when submit
    if (validateFieldInput(argsCommon)) {
        argsCommon.setIsLoading(false);
        return;
    }

    let fieldListInState = cloneDeep(argsCommon.fieldListInState);
    let fieldListUpdate = [];
    let fieldListCreate = [];
    let fieldListCreateParams = [];
    let fieldListUpdateParams = {
        arrFieldUpdate: [],
        arrItemAddNew : []
    };

    argsCommon.fieldAddList.forEach(field => {
        if (isAddNewField(field)) {
            fieldListCreate.push(field);
        } else {
            fieldListUpdate.push(field);
        }
    });

    // Prepare params
    if (!Utils.isEmptyArray(fieldListCreate)) {
        // call api create field
        fieldListCreateParams = buildCreateFieldRequest(fieldListCreate, argsCommon.projectDetail);
    }

    // submit update using project
    let cloneFieldAddList = cloneDeep(argsCommon.fieldAddList);
    let fieldListForUpdate = cloneDeep(argsCommon.fieldLisForUpdate);
    fieldListUpdate.forEach(field => {
        let order = Utils.isEmpty(fieldListForUpdate[`${field.id}`]?.order) ? field.order : fieldListForUpdate[`${field.id}`].order;
        // update data
        fieldListForUpdate[`${field.id}`] = cloneDeep(field);
        fieldListForUpdate[`${field.id}`].order = order;

        let hideInProject = Utils.isEmpty(fieldListForUpdate[`${field.id}`]?.hideInProject) ? field.hideInProject : fieldListForUpdate[`${field.id}`].hideInProject;
        fieldListForUpdate[`${field.id}`].hideInProject = hideInProject;
    });


    let fieldListClone = cloneDeep(fieldListInState);
    // Edit field - generate requestInputData
    let requestInputData = [];
    let isProjectInuseRestore = [];
    if (!Utils.isEmptyObject(fieldListForUpdate)) {
        Object.keys(fieldListForUpdate).forEach(id => {
            let field = fieldListForUpdate[id];
            field.updator = argsCommon.userDetail.id

            let unusedInProjectList = []
            let usingProjects = Utils.isEmptyArray(field.usingProjects) ? [] : field.usingProjects;
            let isExist = usingProjects.includes(argsCommon.projectDetail.id);

            // handler checkbox
            if (field.isUsingProject && !isExist) {
                // if not exist then push projectId to usingProjects
                usingProjects.push(argsCommon.projectDetail.id);
            }

            // handler uncheckbox
            if (!field.isUsingProject && isExist) {
                usingProjects = usingProjects.filter(projectId => projectId !== argsCommon.projectDetail.id);
                unusedInProjectList.push(argsCommon.projectDetail.id);
            }
            field.usingProjects = usingProjects;
            field.unusedInProjectList = unusedInProjectList

            // comment for now
            // Update for status field
            // if (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW) {
            //     let currentItemList = cloneDeep(field.itemList);
            //     let currentDefaultItemList = cloneDeep(field.defaultItemList);
            //     let newDefaultItemList = [];

            //     if (!Utils.isEmptyArray(currentDefaultItemList)) {
            //         for (const defaultItem of currentDefaultItemList) {
            //             let indexInItemList = Utils.findIndexInArrayById(defaultItem.id, currentItemList);
            //             if (indexInItemList === -1) {
            //                 newDefaultItemList.push(defaultItem);
            //                 continue;
            //             }
            //             let currentItem = cloneDeep(defaultItem);
            //             let newStructure = currentItemList[indexInItemList].structure || {};
            //             currentItem.structure = JSON.stringify(newStructure);
            //             newDefaultItemList.push(currentItem);
            //         }
            //     }

            //     field.defaultItemList = newDefaultItemList;

            //     // Update in list fieldListInState
            //     let indexInFieldListInState = Utils.findIndexInArrayById(field.id, fieldListClone);
            //     if (indexInFieldListInState !== -1) {
            //         fieldListClone.splice(indexInFieldListInState, 1, field);
            //     }

            //     // Update in list fieldAddList
            //     let indexInFieldAddList = Utils.findIndexInArrayById(field.id, cloneFieldAddList);
            //     if (indexInFieldAddList !== -1) {
            //         cloneFieldAddList.splice(indexInFieldAddList, 1, field);
            //     }
            // }

            isProjectInuseRestore.push({id: field.id, isProjectInuse: field.isProjectInuse})
            requestInputData.push(field);
        });
       
        requestInputData = buildEditFieldRequest(requestInputData, argsCommon.projectDetail, Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD);
    }

    // Edit field and field item
    if (!Utils.isEmptyArray(requestInputData.requestFieldList)) {
        let arrFieldUpdate = [];
        requestInputData.requestFieldList.forEach(fieldItem => {
            const shareRangeUpdateData = getNewShareRangeOfFiled(fieldItem);
            fieldItem.newShareOption = shareRangeUpdateData.newShareOption;
            fieldItem.newUsage = shareRangeUpdateData.newUsage;
            fieldItem.newShareRange = shareRangeUpdateData.newShareRange;

            delete fieldItem.isUsingInCategories;
            delete fieldItem.formCategories;

            arrFieldUpdate.push({
                id: fieldItem.id,
                ...fieldItem
            })
        });
        fieldListUpdateParams.arrFieldUpdate = arrFieldUpdate;
    }

    // Edit field and add new item when edit
    if (!Utils.isEmptyArray(requestInputData.addNewItemList)) {
        requestInputData.addNewItemList.forEach(itemAddNew => {
            let itemData = itemAddNew.item;
            let parentFieldData = itemAddNew.field;
            let usage = '';

            switch (parentFieldData.type) {
                case Constant.FORM_TYPE.FIELD_WORKFLOW:
                    usage = Constant.FORM_USAGE.STATUS;
                    break;
                case Constant.FORM_TYPE.FIELD_TAG:
                    usage = Constant.FORM_USAGE.TAG;
                    break;
                default:
                    break;
            }
            if (!usage) {
                return;
            }

            let newItemData = {
                usage: usage,
                name: itemData.name,
                affiliationOrganization: parentFieldData.affiliationOrganization,
                affiliationProject: parentFieldData.affiliationProject,
                affiliationField: parentFieldData.id,
                creator: argsCommon.userDetail.id,
                updator: argsCommon.userDetail.id,
                type: '',
                hitNumber: 0,
                structure: itemData.structure,
                viewForCustomer: itemData.viewForCustomer,
                definition: Constant.FORM_DEFINITION.USER,
                explanation: JSON.stringify({}),
                usingProjects: [],
                dummyId: itemData.id,
            };

            fieldListUpdateParams.arrItemAddNew.push(newItemData);
        })
    }

    // Call API
    let paramsUpdateFieldList = {
        method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.UPDATE_FIELD_LIST,
        corporationId: argsCommon.corporationDetail.id,
        projectInuseId: argsCommon.projectDetail.id,
        userId: argsCommon.userDetail.id,
        fieldAddList: JSON.stringify(fieldListCreateParams),
        fieldUpdateData: fieldListUpdateParams,
    }

    let cloneArrFieldUpdate = cloneDeep(fieldListUpdateParams.arrFieldUpdate);
    const batchSize = 50;
    let promise = [];

    for (let i = 0; i < cloneArrFieldUpdate.length; i+= batchSize) {
         // create a new fieldUpdateData object in each iteration of the loop
        let fieldUpdateData = {
            ...fieldListUpdateParams,
            arrFieldUpdate: cloneDeep(cloneArrFieldUpdate).slice(i, i + batchSize)
        };

        let paramsUpdateFieldListClones = {
            method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.UPDATE_LIST_FIELD_MANAGEMENT,
            corporationId: argsCommon.corporationDetail.id,
            projectInuseId: argsCommon.projectDetail.id,
            userId: argsCommon.userDetail.id,
            fieldUpdateData,
        }
        promise.push(updateFormField(argsCommon.API, paramsUpdateFieldListClones));
    }


    let resFieldListUpdated = await Promise.all(promise);
    let fieldEditDatas = [];

    for (let res of resFieldListUpdated) {
        let listItem = Utils.convertJSONDataToObject(res?.fieldEditData);
        fieldEditDatas = [...fieldEditDatas, ...listItem];
    }

    let updateFieldListResult = await updateFormField(argsCommon.API, paramsUpdateFieldList);
    updateFieldListResult.fieldEditData = JSON.stringify(fieldEditDatas);

    if (!updateFieldListResult || !updateFieldListResult.status) {
        return;
    }

    // Update after call API

    // Update after add field
    if (!Utils.isEmptyArray(fieldListCreateParams)) {
        // reset field type 
        argsCommon.setFieldTypeSelectedList([]);

        let cloneFieldList = cloneDeep(argsCommon.fieldListInState);
        let createFieldResult = Utils.convertJSONDataToObject(updateFieldListResult?.fieldListAddNew);
        if (!Utils.isEmptyArray(createFieldResult)) {
            createFieldResult.forEach(resField => {
                let fieldData = resField.field;

                let defaultItemList = Utils.isEmptyArray(resField.itemList) ? [] : resField.itemList;
                let itemList = [];
                switch (fieldData.type) {
                    case Constant.FORM_TYPE.FIELD_TAG:
                        defaultItemList.forEach(item => {
                            itemList.push(generateItemFieldTag(item));
                        });
                        break;
                    case Constant.FORM_TYPE.FIELD_WORKFLOW:
                        defaultItemList.forEach(item => {
                            itemList.push(generateItemFieldStatus(item));
                        });
                        break;
                    default:
                        break;
                }

                fieldData.structure = JSON.parse(fieldData.structure);
                fieldData.name = JSON.parse(fieldData.name);
                fieldData.order = JSON.parse(fieldData.order);
                // fieldData.isUsingProject = field.isUsingProject;

                fieldData.isShowInfo = false;
                fieldData.isErrorValidate = false;
                fieldData.isProjectInuse = true;

                fieldData.itemList = itemList;
                fieldData.defaultItemList = defaultItemList;

                cloneFieldList = [fieldData].concat(cloneFieldList);
            });

            argsCommon.enqueueSnackbar(buildSnackbarMessage('FIELDFORMMSG002'), {
                variant: 'success',
                autoHideDuration: 3000
            });
        }

        // update fieldList in state
        argsCommon.setFieldAddList([]);
        argsCommon.setFieldList(cloneFieldList);
        argsCommon.setFieldListInState(sortFieldListByCreator(cloneFieldList, argsCommon.userDetail.id));

        fieldListInState = sortFieldListByCreator(cloneFieldList, argsCommon.userDetail.id);
    }

    // Update after edit field
    let fieldEditData = Utils.convertJSONDataToObject(updateFieldListResult.fieldEditData);
    let fieldEditItemData = Utils.convertJSONDataToObject(updateFieldListResult.fieldEditItemData);

    if (!Utils.isEmptyObject(fieldListForUpdate)) {
        if (!Utils.isEmptyArray(fieldListUpdateParams.arrFieldUpdate) && fieldEditData && !Utils.isEmptyArray(fieldEditData)) {
            fieldEditData.forEach(fieldData => {
                if (!Utils.isEmptyObject(fieldData) && (fieldData.usage === Constant.FORM_USAGE.FIELD || fieldData.usage === Constant.FORM_USAGE.FIELD_GLOBAL)) {
                    fieldListClone.forEach(item => {
                        if (item.id === fieldData.id) {
                            item.name = JSON.parse(fieldData.name);
                            item.affiliationOrganization = fieldData.affiliationOrganization;
                            item.affiliationProject = fieldData.affiliationProject;
                            item.affiliationField = fieldData.affiliationField;
                            item.createdAt = fieldData.createdAt;
                            item.updatedAt = fieldData.updatedAt;
                            item.creator = fieldData.creator;
                            item.updator = fieldData.updator;
                            item.type = fieldData.type;
                            item.structure = JSON.parse(fieldData.structure);
                            item.viewForCustomer = JSON.parse(fieldData.viewForCustomer);
                            item.definition = fieldData.definition;
                            item.explanation = JSON.parse(fieldData.explanation);
                            item.usingProjects = fieldData.usingProjects;
                            item.order = JSON.parse(fieldData.order);
                            item.usage = fieldData.usage
                            item.shareOption = fieldData.shareOption
                            item.shareRange = fieldData.shareRange;
                            item.hideInProject = fieldData.hideInProject;
                            // item.orderObject = JSON.parse(fieldData.order);
                            item.hasValue = fieldData.hasValue;
                            item.usingForms = JSON.parse(fieldData.usingForms);
                        }
                        isProjectInuseRestore.forEach(isProjectInUseItem => {
                            if(item.id === isProjectInUseItem.id) {
                                item.isProjectInuse = isProjectInUseItem.isProjectInuse;
                            }
                        })
                       
                    });
                }
            })
        }
    
        if (!Utils.isEmptyArray(fieldListUpdateParams.arrItemAddNew) && fieldEditItemData && !Utils.isEmptyArray(fieldEditItemData)) {
            fieldEditItemData.forEach(createdItemData => {
                if (!Utils.isEmptyObject(createdItemData)) {
                    let parentFieldId = createdItemData.affiliationField;
                    let parentFieldData = fieldListClone.find(field => field.id === parentFieldId);

                    if (parentFieldData && !Utils.isEmptyObject(parentFieldData)) {
                        // update id of field
                        if (createdItemData.usage !== Constant.FORM_USAGE.FIELD) {
                            // Update parent field data
                            let parentFieldItemList = cloneDeep(parentFieldData.itemList);
                            let indexInParentFieldItemList = Utils.findIndexInArrayById(createdItemData?.dummyId, parentFieldItemList);
                            if (indexInParentFieldItemList !== -1) {
                                parentFieldItemList[indexInParentFieldItemList].id = createdItemData.id;
                            }
                            parentFieldData.itemList = parentFieldItemList;
                            parentFieldData.defaultItemList.push(createdItemData);
                        }
                        parentFieldData.isShowInfo = false;
            
            
                        // Update in list fieldListInState
                        let indexInFieldListInState = Utils.findIndexInArrayById(parentFieldData.id, fieldListClone);
                        if (indexInFieldListInState !== -1) {
                            fieldListClone.splice(indexInFieldListInState, 1, parentFieldData);
                        }
            
                        // Update in list fieldAddList
                        let indexInFieldAddList = Utils.findIndexInArrayById(parentFieldData.id, cloneFieldAddList);
                        if (indexInFieldAddList !== -1) {
                            cloneFieldAddList.splice(indexInFieldAddList, 1, parentFieldData);
                        }
                    }
                }
            })
        }

        cloneFieldAddList.forEach(field => Object.assign(field, {isShowInfo: false}))
        // update fieldAddList, fieldListInState, setFieldLisForUpdate, currentUpdateField in state
        argsCommon.setFieldAddList(cloneFieldAddList);
        argsCommon.setFieldListInState(sortFieldListByCreator(fieldListClone, argsCommon.userDetail.id));
        argsCommon.setFieldLisForUpdate({});

        argsCommon.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    }

    argsCommon.setIsChangeData(false);
    argsCommon?.setIsAllFieldValid(false);
    argsCommon?.setFieldAddList([]);
    if(argsCommon?.setTriggerReload) {
        argsCommon?.setTriggerReload(!argsCommon?.triggerReload)
    } else {
        argsCommon.setIsLoading(false);
    }
};

export const onSubmitTagItems = async argsCommon => {
    argsCommon.setIsLoading(true);
    const updatedField = argsCommon?.currentUpdateField;

    let fieldListUpdate = [];
    let fieldListCreate = [];
    let fieldListCreateParams = [];
    let fieldListUpdateParams = {
        arrFieldUpdate: [],
        arrItemAddNew: []
    };

    fieldListUpdate = argsCommon.fieldAddList.filter(field => field.id === updatedField.id)
    // Prepare params
    if (!Utils.isEmptyArray(fieldListCreate)) {
        // call api create field
        fieldListCreateParams = buildCreateFieldRequest(fieldListCreate, argsCommon.projectDetail);
    }

    // submit update using project
    let fieldListForUpdate = {}

    fieldListUpdate.forEach(field => {
        let order = Utils.isEmpty(fieldListForUpdate[`${field.id}`]?.order)
            ? field.order
            : fieldListForUpdate[`${field.id}`].order;
        // update data
        fieldListForUpdate[`${field.id}`] = cloneDeep(field);
        fieldListForUpdate[`${field.id}`].order = order;
    });

    // Edit field - generate requestInputData
    let requestInputData = [];
    if (!Utils.isEmptyObject(fieldListForUpdate)) {
        Object.keys(fieldListForUpdate).forEach(id => {
            let field = fieldListForUpdate[id];
            field.updator = argsCommon.userDetail.id;

            let unusedInProjectList = [];
            let usingProjects = Utils.isEmptyArray(field.usingProjects) ? [] : field.usingProjects;
            let isExist = usingProjects.includes(argsCommon.projectDetail.id);

            // handler checkbox
            if (field.isUsingProject && !isExist) {
                // if not exist then push projectId to usingProjects
                usingProjects.push(argsCommon.projectDetail.id);
            }

            // handler uncheckbox
            if (!field.isUsingProject && isExist) {
                usingProjects = usingProjects.filter(
                    projectId => projectId !== argsCommon.projectDetail.id
                );
                unusedInProjectList.push(argsCommon.projectDetail.id);
            }
            field.usingProjects = usingProjects;
            field.unusedInProjectList = unusedInProjectList;
            requestInputData.push(field);
        });
        requestInputData = buildEditFieldRequest(requestInputData, argsCommon.projectDetail, Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM);
    }

    // Edit field and field item
    if (!Utils.isEmptyArray(requestInputData.requestFieldList)) {
        let arrFieldUpdate = [];
        for(let fieldItem of requestInputData.requestFieldList) {
            const shareRangeUpdateData = getNewShareRangeOfFiled(fieldItem);
            fieldItem.newShareOption = shareRangeUpdateData.newShareOption;
            fieldItem.newUsage = shareRangeUpdateData.newUsage;
            fieldItem.newShareRange = shareRangeUpdateData.newShareRange;

            delete fieldItem.isUsingInCategories;
            delete fieldItem.formCategories;
            delete fieldItem.masterKnowledge;

            // Validate name empty
            if (!fieldItem.name) {
                continue;
            }

            let itemNameObject = Utils.convertJSONDataToObject(fieldItem.name);
            let itemName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, itemNameObject);
            if (!itemName) {
                continue;
            }

            arrFieldUpdate.push({
                id: fieldItem.id,
                ...fieldItem
            });
        }

        fieldListUpdateParams.arrFieldUpdate = arrFieldUpdate;
    }

    // Edit field and add new item when edit
    if (!Utils.isEmptyArray(requestInputData.addNewItemList)) {
        requestInputData.addNewItemList.forEach(itemAddNew => {
            const itemData = itemAddNew.item;
            const parentFieldData = itemAddNew.field;
            const newItemData = {
                usage: Constant.FORM_USAGE.TAG,
                name: itemData.name,
                affiliationOrganization: parentFieldData.affiliationOrganization,
                affiliationProject: parentFieldData.affiliationProject,
                affiliationField: parentFieldData.id,
                creator: argsCommon.userDetail.id,
                updator: argsCommon.userDetail.id,
                type: '',
                hitNumber: 0,
                structure: itemData.structure,
                viewForCustomer: itemData.viewForCustomer,
                definition: Constant.FORM_DEFINITION.USER,
                explanation: JSON.stringify({}),
                usingProjects: [],
                dummyId: itemData.id
            };

            fieldListUpdateParams.arrItemAddNew.push(newItemData);
        });
    }

    // Call API
    const paramsUpdateFieldList = {
        method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.UPDATE_FIELD_LIST,
        corporationId: argsCommon.corporationDetail.id,
        projectInuseId: argsCommon.projectDetail.id,
        userId: argsCommon.userDetail.id,
        fieldAddList: JSON.stringify(fieldListCreateParams),
        fieldUpdateData: fieldListUpdateParams
    };

    const cloneArrFieldUpdate = cloneDeep(fieldListUpdateParams.arrFieldUpdate);
    const batchSize = 50;
    let promise = [];

    for (let i = 0; i < cloneArrFieldUpdate.length; i += batchSize) {
        // create a new fieldUpdateData object in each iteration of the loop
        const fieldUpdateData = {
            ...fieldListUpdateParams,
            arrFieldUpdate: cloneDeep(cloneArrFieldUpdate).slice(i, i + batchSize)
        };
        const paramsUpdateFieldListClones = {
            method: Constant.FORM_FIELD_MANAGEMENT_ACTION_FLAG.UPDATE_LIST_FIELD_MANAGEMENT,
            corporationId: argsCommon.corporationDetail.id,
            projectInuseId: argsCommon.projectDetail.id,
            userId: argsCommon.userDetail.id,
            fieldUpdateData
        };
        promise.push(updateFormField(argsCommon.API, paramsUpdateFieldListClones));
    }
    const resFieldListUpdated = await Promise.all(promise);
    let fieldEditDatas = [];

    for (let res of resFieldListUpdated) {
        let listItem = Utils.convertJSONDataToObject(res?.fieldEditData);
        if (!Utils.isEmptyArray(listItem)) {
            fieldEditDatas = [...fieldEditDatas, ...listItem];
        }
    }
    let updateFieldListResult = await updateFormField(argsCommon.API, paramsUpdateFieldList);
    updateFieldListResult.fieldEditData = JSON.stringify(fieldEditDatas);

    if (updateFieldListResult.status) {
        argsCommon?.enqueueSnackbar(buildSnackbarMessage('MSG-CM-UPDATE-DATA-SUCCESS'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        if (argsCommon?.setTriggerReload) {
            argsCommon?.setTriggerReload(Date.now());
        }
    }
    argsCommon?.setIsLoading(false);
};



/**
 * check isProjectUsingSystemForm
 * @param {*} formList 
 * @param {*} projectId 
 * @returns status
 */
export const isProjectUsingSystemForm = (formList, type) => {
    let isUsing = false;
    let typeList = [Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST, Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK];

    if (type) {
        typeList = [type];
    }

    if (!Utils.isEmptyArray(formList)) {
        for (const form of formList) {
            if (
                form.definition === Constant.FORM_DEFINITION.SYSTEM &&
                typeList.includes(form.type) &&
                form.isProjectInuse
            ) {
                isUsing = true;
                break;
            }
        }
    }

    return isUsing;
};

/**
 * Duplicate field
 * @param {*} argsCommon 
 * @param {*} field 
 */
export const duplicateField = (argsCommon, field) => {
    // fieldList
    let fieldList = cloneDeep(argsCommon.fieldList);
    let fieldListInStateClone = cloneDeep(argsCommon.fieldListInState);
    let cloneField = fieldListInStateClone.find(x => x.id === field.id);
    // cloneDeep(field);

    // remove time not clone
    delete cloneField.createdAt;
    delete cloneField.updatedAt;
    delete cloneField.hasValue;
    delete cloneField.usingForms;
    delete cloneField.shareRange;
    delete cloneField.sharedFormList;
    delete cloneField.sharedFieldList

    let nameCloneField;
    try {
        nameCloneField = JSON.parse(cloneField.name);
    } catch (err) {
        nameCloneField = cloneField.name;
    }

    nameCloneField[Constant.LANGUAGE_TYPE.JP] = {
        A: 'F',
        text: `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, cloneField.name)} - Copy`
    };

    let saveOrder = getNewOrderForNewField(argsCommon.fieldDragDropList, argsCommon.projectDetail.id, argsCommon.fieldListInState, argsCommon.fieldAddList);
    // update data of clone field
    cloneField.id = Date.now().toString();
    cloneField.affiliationOrganization = localStorageUtil.getAffiliationOrganization()
    cloneField.affiliationProject = argsCommon.projectDetail.id;
    cloneField.creator = argsCommon.userDetail.id;
    cloneField.updator = argsCommon.userDetail.id;
    cloneField.isProjectInuse = false;
    cloneField.isUsingProject = false;
    cloneField.usingProjects = field.usingProjects;
    cloneField.isShowInfo = true;
    cloneField.clientFieldType = Constant.CLIENT_FIELD_TYPE.DUPLICATE_FIELD;
    cloneField.name = nameCloneField;
    cloneField.order = Utils.isEmpty(cloneField.order) ? JSON.stringify({}) : cloneField.order;
    cloneField.saveOrder = { [`${argsCommon.projectDetail.id}`]: saveOrder };
    cloneField.relatedMasterForm =
        Utils.getPrefixOfId(field?.relatedMasterForm) === 'form'
            ? field?.relatedMasterForm
            : Constant.RELATED_MASTER_FORM_DEFAULT;
    cloneField.usage = Constant.FORM_USAGE.FIELD

    let indexInFieldList = Utils.findIndexInArrayById(field.id, fieldList);
    fieldList.splice(indexInFieldList + 1, 0, cloneField);
    argsCommon.setFieldList(fieldList);

    // field add list
    let fieldAddList = cloneDeep(argsCommon.fieldAddList);
    fieldAddList.push(cloneField);
    argsCommon.setFieldAddList(fieldAddList);
}


/**
 * showFieldInfo
 * @param {*} argsCommon 
 * @param {*} index 
 * update fieldList state
 */
export const showFieldInfo = (argsCommon, field) => {
    // Update field list
    let currentFieldList = cloneDeep([...argsCommon.fieldList]);
    let indexInFieldList = Utils.findIndexInArrayById(field.id, currentFieldList);
    if (indexInFieldList !== -1) {
        currentFieldList[indexInFieldList].isShowInfo = currentFieldList[indexInFieldList].isShowInfo ? false : true;
        argsCommon.setFieldList(currentFieldList);
    }

    // update fieldAddList
    let cloneFieldAddList = cloneDeep([...argsCommon.fieldAddList]);
    let indexInFieldAddList = Utils.findIndexInArrayById(field.id, cloneFieldAddList);
    if (indexInFieldAddList === -1) {
        let newField = cloneDeep(field);
        newField.isShowInfo = newField.isShowInfo ? false : true;
        cloneFieldAddList.push(newField);
    } else {
        cloneFieldAddList[indexInFieldAddList].isUsingProject = field.isUsingProject;
        cloneFieldAddList[indexInFieldAddList].isShowInfo = cloneFieldAddList[indexInFieldAddList].isShowInfo ? false : true;
        cloneFieldAddList[indexInFieldAddList].structure = Utils.convertJSONDataToObject(field.structure);
    }
    argsCommon.setFieldAddList(cloneFieldAddList);
};



/**
 * remove duplicate field
 * @param {*} argsCommon 
 * @param {*} index 
 * 
 */
export const removeFieldInFieldList = (argsCommon, field) => {
    let fieldList = Utils.removeItemInArrayById(field.id, argsCommon.fieldList);
    argsCommon.setFieldList(fieldList);

    let fieldAddList = Utils.removeItemInArrayById(field.id, argsCommon.fieldAddList);
    argsCommon.setFieldAddList(fieldAddList);
};



/**
 * validateItemListFieldStatus
 * @param {*} itemList 
 * @returns status, itemList
 */
export const validateItemListFieldStatus = (itemList) => {
    if (Utils.isEmptyArray(itemList)) {
        return { status: false, itemList, enableBtnSave: false }
    }

    let newItemList = cloneDeep(itemList);
    let status = true;
    let enableBtnSave = true;
    for (let [index, item] of newItemList.entries()) {
        let itemName = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            item.name
        );
        let itemNameViewForCustomer = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            item.viewForCustomer
        );
        itemName = itemName.trim();
        itemNameViewForCustomer = itemNameViewForCustomer.trim();
        if (!itemName || itemName.length > Constant.MAX_LENGTH.FIELD_NAME) {
            status = false;
            newItemList[index].isErrorValidate = true;
            newItemList[index].isShowInfo = true;
            item.errorMsg['name'] = Utils.isEmptyString(itemName) ? trI18n('STAMSG001') : `${Constant.MAX_LENGTH.FIELD_NAME}文字の以下で入力してください。`;
            
            if (Utils.isEmptyString(itemName)) {
                enableBtnSave = false;
            }
        } else {
            newItemList[index].isErrorValidate = false;
            newItemList[index].isShowInfo = false;
            item.errorMsg['name'] = '';
        }

        if (itemNameViewForCustomer && itemNameViewForCustomer.length > Constant.MAX_LENGTH.FIELD_NAME) {
            status = false;
            newItemList[index].isErrorValidate = true;
            newItemList[index].isShowInfo = true;
            item.errorMsg['viewForCustomer'] = `${Constant.MAX_LENGTH.FIELD_NAME}文字の以下で入力してください。`;
        } else {
            newItemList[index].isErrorValidate = newItemList[index].isErrorValidate ? newItemList[index].isErrorValidate : false;
            item.errorMsg['viewForCustomer'] = '';
        }
        newItemList[index].name[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: itemName,
        };
        newItemList[index].viewForCustomer[Constant.LANGUAGE_TYPE.JP] = {
            A: 'F',
            text: itemNameViewForCustomer,
        };;
    }

    return { status, itemList: newItemList, enableBtnSave }
};

const checkExistCommonItem = (array1,array2) => {
    let result = false;
    array1?.forEach((item) => {
        if(array2?.includes(item)){
            result = true;
            return true 
        }
    })
    return result
}

const checkFiledCanInactive = (listIdOfListUseField,listFormOfAffiliationProject,fieldId) => {
    let isCanInactive = true
    if(!Utils.isEmptyArray(listFormOfAffiliationProject)){
        for(let index = 0; index < listFormOfAffiliationProject.length; index++){
            let listIdOfTitle = listFormOfAffiliationProject[index].listFiledIdOfTitle
            if(!Utils.isEmptyArray(listIdOfTitle) && listIdOfTitle?.includes(fieldId)){
                const listIdOfTitleWithoutIdOfField = listIdOfTitle.filter(id =>  id !== fieldId);
                const isExistCommonItem = checkExistCommonItem(listIdOfTitleWithoutIdOfField,listIdOfListUseField)
                if(!isExistCommonItem){
                    isCanInactive = false;
                    break
                }
            }
        }
    }

    return isCanInactive
}

/**
 * Handler click using projects
 * @param {*} argsCommon 
 * @param {*} field 
 * @param {*} isUsingProject 
 * @param {*} projectDetail 
 */
export const onClickUsingProjects = (argsCommon, field, isUsingProject, projectDetail) => {
    argsCommon.setIsChangeData(true);
    
    
    // if field system then break
    // if (isSystemField(field)) {
    //     return;
    // }
    if (!isUsingProject) {
        try {
            const result = checkFiledCanInactive(
                argsCommon.listIdOfListUseField,
                argsCommon.listFormOfAffiliationProject,
                field.id
            );
            if (!result) {
                argsCommon.setIsOpenPopupCannotInactiveField(true);
                return;
            }
        } catch (error) {
            console.log('error :>> ', error);
        }
    }
    let fieldList = cloneDeep(argsCommon.fieldList);

    let index = Utils.findIndexInArrayById(field.id, fieldList);
    let usingProjects = Utils.isEmptyArray(fieldList[index].usingProjects) ? [] : fieldList[index].usingProjects;
    if (!isUsingProject) {
        usingProjects = usingProjects.filter(projectId => projectId !== projectDetail.id);
    } else {
        let isExitProject = usingProjects.includes(projectDetail.id);
        if (!isExitProject) {
            usingProjects.push(projectDetail.id);
        }
    }

    fieldList[index].usingProjects = usingProjects;
    fieldList[index].isUsingProject = isUsingProject;
    fieldList[index].isProjectInuse = isUsingProject;


    // update field add list
    let fieldAddList = cloneDeep(argsCommon.fieldAddList);
    let indexInFieldAddList = Utils.findIndexInArrayById(field.id, fieldAddList);
    if (indexInFieldAddList !== -1) {
        fieldAddList[indexInFieldAddList].usingProjects = usingProjects;
        fieldAddList[indexInFieldAddList].isUsingProject = isUsingProject;
        fieldAddList[indexInFieldAddList].isProjectInuse = isUsingProject;
        argsCommon.setFieldAddList(fieldAddList);
    }

    // update using project in field list using project
    if (!isAddNewField(field)) {
        let fieldLisForUpdate = cloneDeep(argsCommon.fieldLisForUpdate);
        let fieldClone = cloneDeep(field);
        fieldClone.isUsingProject = isUsingProject;
        fieldClone.isProjectInuse = isUsingProject;
        fieldClone.order = Utils.convertJSONDataToObject(fieldClone.order)
        fieldClone.order[`${argsCommon.projectDetail.id}`] = Utils.isEmptyArray(argsCommon.fieldUseList) ? 0 : argsCommon.fieldUseList.length;
        fieldList[index].order = Utils.convertJSONDataToObject(fieldList[index].order)
        fieldList[index].order[`${argsCommon.projectDetail.id}`] = Utils.isEmptyArray(argsCommon.fieldUseList) ? 0 : argsCommon.fieldUseList.length;
        fieldClone.hideInProject = Utils.convertJSONDataToObject(fieldClone.hideInProject);
        fieldClone.hideInProject[argsCommon.projectDetail.id] = 0;
        fieldClone.hideInProject = JSON.stringify(fieldClone.hideInProject);
        fieldList[index].hideInProject = Utils.convertJSONDataToObject(fieldList[index].hideInProject);
        fieldList[index].hideInProject[argsCommon.projectDetail.id] = 0;
        if (isUsingProject) {
            // fieldClone.order[`${argsCommon.projectDetail.id}`] = argsCommon.fieldUseList.length;

            // update order in fieldAddList
            fieldAddList.forEach(item => {
                item.order[`${argsCommon.projectDetail.id}`] = item.order[`${argsCommon.projectDetail.id}`] + 1;
            }); 
            argsCommon.setFieldAddList(fieldAddList);
        }
        fieldLisForUpdate[`${field.id}`] = fieldClone;
        fieldList.forEach(fieldItem => {
            fieldItem.order = Utils.convertJSONDataToObject(fieldItem.order);
            let newOrder = 0;
            if (fieldLisForUpdate[fieldItem.id]?.order[`${argsCommon.projectDetail.id}`]) {
                newOrder = fieldLisForUpdate[fieldItem.id]?.order[`${argsCommon.projectDetail.id}`];
            } else if (fieldItem.order[`${argsCommon.projectDetail.id}`]) {
                newOrder = fieldItem.order[`${argsCommon.projectDetail.id}`];
            }
            fieldItem.order[`${argsCommon.projectDetail.id}`] = newOrder;
        });
        argsCommon.setFieldLisForUpdate(fieldLisForUpdate);
    }

    // update field list
    argsCommon.setFieldList(fieldList);
};

/**
 * Delete field by id
 * @param {*} field 
 * @param {*} argsCommon 
 */
export const deleteFieldById = async (field, argsCommon) => {
    argsCommon.setIsLoading(true);
    deleteForm(argsCommon.API, field.id)
        .then(resData => {
            let fieldListInState = cloneDeep(argsCommon.fieldListInState);
            let index = Utils.findIndexInArrayById(field.id, fieldListInState);
            fieldListInState.splice(index, 1);
            argsCommon.setFieldListInState(fieldListInState);
            argsCommon.setIsLoading(false);
        }).catch(err => {
            argsCommon.enqueueSnackbar(buildSnackbarMessage(err.errors[0].message), {
                variant: 'error',
                autoHideDuration: 3000,
            });
            argsCommon.setIsLoading(false);
        });
};

export const clearAllUnsavedChanges = (argsCommon) => {
    // Reset field add list (new fields not saved)
    if (argsCommon.setFieldAddList) {
        argsCommon.setFieldAddList([]);
    }

    // Reset field type selected list (UI of new fields)
    if (argsCommon.setFieldTypeSelectedList) {
        argsCommon.setFieldTypeSelectedList([]);
    }

    // Reset field list for update (order/data changes)
    if (argsCommon.setFieldLisForUpdate) {
        argsCommon.setFieldLisForUpdate({});
    }

    // Reset change data flag
    if (argsCommon.setIsChangeData) {
        argsCommon.setIsChangeData(false);
    }

    // Reset edited data flag
    if (argsCommon.setIsEditedData) {
        argsCommon.setIsEditedData(false);
    }

    // Reset isDirty flag
    if (argsCommon.setIsDirty) {
        argsCommon.setIsDirty(false);
    }

    // Reset formPanelTabClose dirty state (Recoil atom used by FormManagement for tab switching)
    if (argsCommon.setFormPanelTabClose) {
        argsCommon.setFormPanelTabClose(prev => ({...prev, isDirty: false}));
    }

    // Reset current field selected
    if (argsCommon.setCurrentFieldSelected) {
        argsCommon.setCurrentFieldSelected(null);
    }
};

export const deleteFieldByIdWithClearUnsavedChanges = async (field, argsCommon) => {
    argsCommon.setIsLoading(true);

    try {
        // Step 1: Call API to delete field
        const resData = await deleteForm(argsCommon.API, field.id);

        if (resData) {
            // Step 2: Remove deleted field from atom IMMEDIATELY
            // This ensures UI updates right away
            let fieldListInState = cloneDeep(argsCommon.fieldListInState);
            let index = Utils.findIndexInArrayById(field.id, fieldListInState);
            if (index !== -1) {
                fieldListInState.splice(index, 1);
            }
            argsCommon.setFieldListInState(fieldListInState);

            // Step 3: Clear all unsaved changes - reset local states
            // useEffect [fieldListInState] will automatically rebuild fieldList
            clearAllUnsavedChanges(argsCommon);

            argsCommon.setIsLoading(false);
        } else {
            throw new Error('Delete field failed');
        }
    } catch (err) {
        argsCommon.enqueueSnackbar(
            buildSnackbarMessage(err?.errors?.[0]?.message || 'ERRMSG001'),
            {
                variant: 'error',
                autoHideDuration: 3000,
            }
        );
        argsCommon.setIsLoading(false);
    }
};

export const getFieldListInCorp = async (API, corporationId, projectInuse) => {
    // get fieldList
    
    const pageParams = {
        from: 0, 
        size: 300, 
        isGetForList: true
    }
    let fieldList = await getFieldListByCorporation(API, corporationId, pageParams);
    if (!Utils.isEmptyObject(projectInuse) && !Utils.isEmptyArray(fieldList)) {
        fieldList.forEach((field) => {
            field.isProjectInuse =
                !Utils.isEmptyArray(field.usingProjects) &&
                field.usingProjects.includes(projectInuse.id);
            field.isUsingProject = field.isProjectInuse;

            // convert order object string to object
            field.order = Utils.convertJSONDataToObject(field.order);
            field.usingForms = Utils.convertJSONDataToObject(field.usingForms);
        });
    }

    let sortFieldList = sortFieldListByOrder(fieldList, projectInuse);
    return sortFieldList;
}

export const getNewOrderForNewField = (fieldDragDropList, projectDetailId, fieldListInState, fieldAddList) => {
    let maxOrder = 0;

    if (!Utils.isEmptyArray(fieldListInState)) {
        let listUsingField = fieldListInState.filter(field => field.isUsingProject);
        listUsingField.forEach(field => {
            if (field.order && field.order.hasOwnProperty(projectDetailId)) {
                let currentOrder = parseInt(field.order[projectDetailId]);
                if (currentOrder > maxOrder) {
                    maxOrder = currentOrder;
                }
            }
        })
    }

    if (!Utils.isEmptyArray(fieldAddList)) {
        let realityFieldAddList = fieldAddList.filter(fieldAdd => isAddNewField(fieldAdd));
        maxOrder += realityFieldAddList.length;
    }

    return maxOrder + 1;
};


/**
 * Get select project list
 * @param {*} projectList 
 * @returns projectList
 */
export const getSelectProjectList = projectList => {
    let cloneProjectList = cloneDeep(projectList);
    cloneProjectList = cloneProjectList.filter(item => item.type !== Constant.PROJECT_TYPE.BASE && item.type !== Constant.PROJECT_TYPE.CUSTOMER && item.active !== Constant.ACTIVE_FLAG.DELETED);
    return cloneProjectList
};

const getNewShareRangeOfFiled = fieldData => {
    let shareRangeResult = {};
    if (fieldData.newShareOption) {
        shareRangeResult.newShareOption = fieldData.newShareOption;
        switch (fieldData.newShareOption) {
            case Constant.SHARE_OPTION.ALL_ORG:
                shareRangeResult.newUsage = Constant.FORM_USAGE.FIELD_GLOBAL;
                shareRangeResult.newShareRange = [];
                break;
            case Constant.SHARE_OPTION.SPECIFIC_ORG:
                shareRangeResult.newUsage = Constant.FORM_USAGE.FIELD;
                shareRangeResult.newShareRange = fieldData.newShareRange;
                break;
            case Constant.SHARE_OPTION.B2B_CUSTOMER_ORG:
                shareRangeResult.newUsage = Constant.FORM_USAGE.FIELD;
                shareRangeResult.newShareRange = fieldData.newShareRange;
                break;
            case Constant.SHARE_OPTION.B2B_HELPDESK_ORG:
                shareRangeResult.newUsage = Constant.FORM_USAGE.FIELD;
                shareRangeResult.newShareRange =  fieldData.newShareRange;
                break;
            case Constant.SHARE_OPTION.INTERNAL_ORG:
                shareRangeResult.newUsage = Constant.FORM_USAGE.FIELD;
                shareRangeResult.newShareRange = [];
                break;
            default:
                break;
        }
    } else if (fieldData.newShareRange) {
        shareRangeResult.newShareRange = fieldData.newShareRange;
    }
    if(!Utils.isEmptyArray(shareRangeResult.newShareRange)){
        shareRangeResult.newShareRange = Utils.filterDuplicateItemsOfArray(shareRangeResult.newShareRange,Utils.checkArrayIncludesItem)
    }
    return shareRangeResult;
};

/**
 * Check if MCP Server field should be visible
 * @param {Object} corporationDetail - Corporation detail
 * @returns {Boolean} - True if MCP Server field should be visible
 */
export const isShowMCPServerField = (corporationDetail) => {
    // Condition 1: Check contract type is PREMIUM
    if (corporationDetail?.contractType !== Constant.CORPORATION_CONTRACT_TYPE.PREMIUM) {
        return false;
    }
    
    // Condition 2: Check limit value has mcpServer permission
    if (!corporationDetail?.limitValue?.mcpServer) {
        return false;
    }
    
    // Condition 3: Check corporation setting has MCP Server enabled
    const corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
    if (corporationSetting?.usingMCPServer !== Constant.STATUS_SERVICE_PERMISSION.ON) {
        return false;
    }
    
    return true;
};
